import { jsx as r } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const m = (c) => /* @__PURE__ */ r(o, { ...c, children: /* @__PURE__ */ r("path", { d: "M16.665 3.33514H3.33537c-.91662 0-1.66758.75097-1.66758 1.66759v9.99447c0 .9166.75096 1.6676 1.66758 1.6676H16.665c.9167 0 1.6676-.751 1.6676-1.6676V5.00273c0-.92767-.7509-1.66759-1.6676-1.66759ZM3.33537 5.00273H16.665v1.66758H3.33537V5.00273Zm0 9.99447V9.99444H16.665v5.00276H3.33537Z" }) });
export {
  m as CreditCard
};
//# sourceMappingURL=CreditCard.js.map
